import { Observable } from 'rxjs';
import { ReturnTypeModelLimits } from '@src/core/domain/approval-limits/return-approval-limits.model';

export abstract class ApprovalLimitsRepository {
  abstract getApprovalAllLimites(type: string): Observable<ReturnTypeModelLimits>;

  abstract getApprovalStatusLimites(type: {}): Observable<ReturnTypeModelLimits>;
}
